'use client';

import Link from 'next/link';

import { ListingItemType } from '@/slw/entities/home/home.model';

import { ProductItem } from './product-item';
import { HeadingTitleContent } from './heading-title-content';

interface HighPricedListingsProps {
  listings: ListingItemType[];
}

export function HighPricedListings({ listings = [] }: HighPricedListingsProps) {
  return (
    <section className='mt-10 md:mt-20'>
      <HeadingTitleContent title='High-priced Listings' />
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 xl:gap-6'>
        {listings.map((item, idx) => (
          <ProductItem key={`${item.id}_${idx}`} item={item} />
        ))}
      </div>
      <Link href={'/search-results/all-year?orBestOffer=true'} className='view-all font-medium text-primary block mt-3'>
        See all Listing
      </Link>
    </section>
  );
}
